export default function Capitalise(text: string) {
	return text.charAt(0).toUpperCase() + text.slice(1);
}

export function DomainFromEmail(email: string): string {
	if (email.indexOf("@") === -1) return email; // not found
	return email.substring(email.indexOf("@"));
}
